import axios from 'axios';

console.log(import.meta.env)

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export default client;
